'use client';

import type { PropsWithChildren } from 'react';

import { withPromo } from '@/helpers/hocs';
import { FORTUNE_WHEEL_RESTRICTED_GROUPS } from '@/modules/promotions';

function WheelPage({ children }: PropsWithChildren) {
  return children;
}

export default withPromo(WheelPage, {
  redirectUrl: '/',
  promoName: 'fortuneWheel',
  restrictedGroups: FORTUNE_WHEEL_RESTRICTED_GROUPS,
});
